import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./components/Home/Home";
import Contact from "./components/Contact/Contact";
import About from "./components/About/About";
import Media from "./components/Media/Media";
import NewsGrid from "./components/News/NewsGrid";
import Music from "./components/Music/Music";
import Layout from "./Layout";
import "./App.css";
import NotFound from "./NotFound";

const App: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const backgroundImage = isHomePage
    ? "url('/violin2.webp')"
    : "url('/violin2.webp')";
  const backgroundColor = isHomePage ? "rgba(0, 0, 0, 0.6)" : "";

  const is404 = ![
    "/",
    "/contact",
    "/about",
    "/media",
    "/news",
    "/music",
  ].includes(location.pathname);

  return (
    <div
      className="App"
      style={{
        backgroundImage,
        backgroundColor,
      }}
    >
      {is404 ? (
        <NotFound />
      ) : (
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/media" element={<Media />} />
            <Route path="/news" element={<NewsGrid />} />
            <Route path="/music" element={<Music />} />
          </Routes>
        </Layout>
      )}
    </div>
  );
};

export default App;
